import React, { useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid'
import { Button } from '@progress/kendo-react-buttons'

import { BaseDataDialog, ConfirmDeleteDialog, BaseDataGridCommandCell } from '../components'

export default ({ entities, createAction, updateAction, deleteAction, fieldDescription }) => {
    const dispatch = useDispatch()

    const [entityInEdit, setEntityInEdit] = useState(undefined)
    const [entityToRemove, setEntityToRemove] = useState(undefined)

    const [skip, setSkip] = useState(0)
    const [take, setTake] = useState(12)

    const pageChange = (event) => {
        setSkip(event.page.skip)
        setTake(event.page.take)
    }


    const cloneEntity = (entity) => {
        return Object.assign({}, entity)
    }

    const edit = (dataItem) => {
        setEntityInEdit(cloneEntity(dataItem))
    }

    const insert = () => {
        setEntityInEdit({})
    }

    const confirmRemove = (entity) => {
        setEntityToRemove(entity)
    }

    const remove = () => {
        dispatch(deleteAction(entityToRemove))
        setEntityToRemove(undefined)
    }

    const cancel = () => {
        setEntityInEdit(undefined)
        setEntityToRemove(undefined)
    }

    const save = (entity) => {
        const isNewEntity = entity.id === undefined

        if (isNewEntity) {
            dispatch(createAction(entity))
        } else {
            dispatch(updateAction(entity))
        }

        setEntityInEdit(undefined)
    }

    return (
        <div>
            <StyledGrid 
            data={[...entities].slice(skip, take + skip)}
            skip={skip}
            take={take} 
            total={entities.length}
            pageable={true}
            onPageChange={pageChange}>
                <GridToolbar>
                    <Button primary onClick={insert}>Hinzufügen</Button>
                </GridToolbar>
                {fieldDescription.map((field) => (
                    <Column key={field.name} field={field.name} title={field.description}/>
                ))}
                <Column cell={BaseDataGridCommandCell(edit, confirmRemove)} width="120px"/>
            </StyledGrid>
            {entityInEdit && <BaseDataDialog dataItem={entityInEdit} cancel={cancel} save={save}
                                             dialogContentFields={fieldDescription}/>}
            {entityToRemove && <ConfirmDeleteDialog cancel={cancel} remove={remove}/>}
        </div>
    )
}

const StyledGrid = styled(Grid)` 
    height: 80vh;
`



// WEBPACK FOOTER //
// ./src/pages/BaseData.js